import angular from 'angular'
import angularSlider from 'angularjs-slider'
import ngRedux from 'ng-redux'
import { combineReducers } from 'redux'
import ReduxThunk from 'redux-thunk'
import logger from 'redux-logger'
import { persistStore, autoRehydrate } from 'redux-persist'
import { createMiddleware } from 'redux-beacon'
import { logger as reduxBeaconLogger } from 'redux-beacon/extensions/logger'
import { GoogleAnalytics } from 'redux-beacon/targets/google-analytics'
import 'angularjs-slider/dist/rzslider.css'

import quotationReducer from './quotation.reducer'
import quotationEventsMaps from './quotation.googleevents'
import QuotationMiddleware from './quotationMiddleware.service'
import Quotation from './quotation'
import QuotationFormInitial from './component/quotationFormInitial'
import QuotationFormLandscape from './component/quotationFormLandscape'
import QuotationFormConsumption from './component/quotationFormConsumption'
import QuotationModalIneligibility from './component/quotationModalIneligibility'
import QuotationResultActions from './component/quotationResultActions'
import QuotationResultAnnualConsumption from './component/quotationResultAnnualConsumption'
import QuotationResultLandscape from './component/quotationResultLandscape'
import QuotationResultPot from './component/quotationResultPot'
import QuotationResultError from './component/quotationResultError'
import QuotationTimetable from './component/quotationTimetable'
import QuotationMobileIntro from './component/quotationMobileIntro'
import QuotationVisitorMain from './component/quotationVisitorMain'
import QuotationVisitorNewsletter from './component/quotationVisitorNewsletter'
import QuotationVisitorFacebook from './component/quotationVisitorFacebook'

/**
 * Used redux library:
 * ng-redux: Allow to use redux paradigm in angularjs 1 to ease state management
 * redux: state management
 * redux-logger: middleware logger to see action + previous/next state
 * redux-thunk: simple middleware to transform async actions to sync actions as redux require sync actions
 * redux-persist: middleware to save current state in local storage & reload the page with user data
 * Redux DevTools - Chrome extension (window.__REDUX_DEVTOOLS_EXTENSION__()): used to debug state & action with Chrome tools
 */
export default angular
.module('unergie.quotation', [ngRedux, angularSlider])
.config(/** @ngInject */($ngReduxProvider) => {
    /* look on https://github.com/angular-redux/ng-redux for specific angularjs redux implementation */
    const reducers = combineReducers({
        quotation: quotationReducer,
    })

    /* Redux DevTools extension allow watching action using chrome extention */
    /* https://github.com/zalmoxisus/redux-devtools-extension */
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        $ngReduxProvider.createStoreWith(
            reducers,
            [ReduxThunk, 'quotationMiddleware', createMiddleware(quotationEventsMaps, GoogleAnalytics, { logger: reduxBeaconLogger }), logger],
            [autoRehydrate(), window.__REDUX_DEVTOOLS_EXTENSION__()],
        )
    } else {
        $ngReduxProvider.createStoreWith(
            reducers,
            [ReduxThunk, 'quotationMiddleware', createMiddleware(quotationEventsMaps, GoogleAnalytics)],
            [autoRehydrate()],
        )
    }
})
.run(/** @ngInject */($ngRedux) => {
    // Persist each state change into local storage
    persistStore($ngRedux, { blacklist: ['@@INIT'] })
})
.factory('quotationMiddleware', QuotationMiddleware)
.component('quotation', Quotation)
.component('quotationFormInitial', QuotationFormInitial)
.component('quotationFormLandscape', QuotationFormLandscape)
.component('quotationFormConsumption', QuotationFormConsumption)
.component('quotationModalIneligibility', QuotationModalIneligibility)
.component('quotationResultActions', QuotationResultActions)
.component('quotationResultAnnualConsumption', QuotationResultAnnualConsumption)
.component('quotationResultLandscape', QuotationResultLandscape)
.component('quotationResultPot', QuotationResultPot)
.component('quotationResultError', QuotationResultError)
.component('quotationTimetable', QuotationTimetable)
.component('quotationMobileIntro', QuotationMobileIntro)
.component('quotationVisitorMain', QuotationVisitorMain)
.component('quotationVisitorNewsletter', QuotationVisitorNewsletter)
.component('quotationVisitorFacebook', QuotationVisitorFacebook)
.name



// WEBPACK FOOTER //
// ./src/states/quotation/quotation.module.js